import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

// Dialog generico de confirmacao pra qualquer acao que exija motivo de
// auditoria (mudar status, suspender, desativar, arquivar). O aviso de
// campo obrigatorio so aparece apos uma tentativa de confirmar sem
// preencher, em vez de so desabilitar o botao em silencio -- generalizado
// a partir do OrganizationStatusDialog (AdminTenancy).
export default function AuditStatusConfirmDialog({
  open,
  title,
  description,
  reason,
  submitting,
  confirmLabel = 'Confirmar',
  confirmColor = 'warning',
  onReasonChange,
  onClose,
  onConfirm,
}) {
  const [attemptedConfirm, setAttemptedConfirm] = React.useState(false);
  const trimmedReason = reason.trim();
  const showReasonWarning = attemptedConfirm && !trimmedReason;

  React.useEffect(() => {
    if (open) {
      setAttemptedConfirm(false);
    }
  }, [open]);

  const handleConfirmClick = () => {
    if (!trimmedReason) {
      setAttemptedConfirm(true);
      return;
    }

    onConfirm();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {description ? (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {description}
            </Typography>
          ) : null}
          <TextField
            fullWidth
            label="Motivo (obrigatório)"
            value={reason}
            onChange={(event) => onReasonChange(event.target.value)}
            disabled={submitting}
            autoFocus
            error={showReasonWarning}
            helperText={showReasonWarning ? 'Informe o motivo para confirmar.' : ' '}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={submitting}>Cancelar</Button>
        <Button
          variant="contained"
          color={confirmColor}
          onClick={handleConfirmClick}
          disabled={submitting}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
